/**
 * 디바이스 감지 유틸
 *
 * 챗봇 위젯이 모바일에서 호출되는지 확인하여
 * tel: 링크 등 네이티브 동작을 결정한다.
 */

export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent;
  const mobileUA = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTouch = 'ontouchstart' in window;
  const isSmallScreen = window.innerWidth <= 768;

  return mobileUA || (isTouch && isSmallScreen);
}

export function canMakePhoneCall(): boolean {
  return isMobileDevice();
}
